import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { UserService } from "../../../services/user.service";
import { ToastService } from "../../../services/toast.service";
import { LoaderService } from "../../../services/loader.service";

@Component({
  selector: 'psc-profile',
  templateUrl: './profile.component.html',
})
export class ProfileComponent implements OnInit {
  formGroup: FormGroup;

  loading: boolean = false;

  profileFields = [
    { label: 'first_name', name: 'firstName', required: true },
    { label: 'last_name', name: 'lastName', required: true },
    { label: 'address', name: 'address', required: true },
    { label: 'mobile_phone', name: 'mobilePhone', required: true },
  ];
  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastService: ToastService,
    private loaderService: LoaderService,
  ) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.userService.getCurrentUserDetails().subscribe((user) => {
      this.formGroup = this.formBuilder.group({
        email: [{
          value: user.email,
          disabled: true,
        }],
        firstName: [user.firstName || ''],
        lastName: [user.lastName || ''],
        address: [user.address || ''],
        mobilePhone: [user.mobilePhone || ''],
      });
      this.loading = false;
    });
  }

  onSubmit() {
    if(!this.formGroup.valid) {
      return;
    }
    this.loaderService.showLoader();
    this.userService.updateCurrentUser(this.formGroup.value).subscribe({
      next: () => {
        /** t(toast.profile.success) **/
        this.toastService.showSuccessToast('toast.profile.success');
      },
    }).add(() => {
      this.loaderService.hideLoader();
    });
  }

}
